import sctToken from "../abis/development/tokens/sctToken";

export default {
  name: "SCT",
  abi: sctToken.abi,
  contractAddress: "0xa747f2aefacdf9b1e19d94ab3a0343a490c684a3",
  decimals: 18,
};
